import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HeroSection from "@/components/HeroSection";
import TrustStrip from "@/components/TrustStrip";
import SignatureRoutes from "@/components/SignatureRoutes";
import AllInclusive from "@/components/AllInclusive";
import WhyObsidian from "@/components/WhyObsidian";
import Testimonials from "@/components/Testimonials";
import AboutUs from "@/components/AboutUs";
import BespokeForm from "@/components/BespokeForm";
import DiplomaticService from "@/components/DiplomaticService";
import WhatsAppButton from "@/components/WhatsAppButton";
import Footer from "@/components/Footer";
import AdminApp from "@/pages/AdminApp";

function LandingPage() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <HeroSection />
      <TrustStrip />
      <SignatureRoutes />
      <AllInclusive />
      <WhyObsidian />
      <Testimonials />
      <AboutUs />
      <BespokeForm />
      <DiplomaticService />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
